// Utilitaire pour convertir une date au format YYYY-MM-DD avec timezone Europe/Paris
export const formatDateToYYYYMMDD = (date: Date): string => {
  if (!date || !(date instanceof Date)) {
    return '';
  }

  // Utiliser la timezone Europe/Paris pour éviter les décalages
  const parisDate = new Date(date.toLocaleString("en-US", { timeZone: "Europe/Paris" }));

  // Extraire année, mois, jour avec padding
  const year = parisDate.getFullYear();
  const month = String(parisDate.getMonth() + 1).padStart(2, '0');
  const day = String(parisDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

// Alternative plus simple qui évite les problèmes de timezone UTC
export const formatDateToYYYYMMDDLocal = (date: Date): string => {
  if (!date || !(date instanceof Date)) {
    return '';
  }

  // Utiliser les méthodes locales pour éviter les conversions UTC
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

// Utilitaire pour afficher une date au format français avec timezone Europe/Paris
export const formatDateToFrenchLocale = (date: Date): string => {
  if (!date || !(date instanceof Date)) {
    return '';
  }

  // Utiliser la timezone Europe/Paris pour l'affichage
  return date.toLocaleDateString("fr-FR", {
    timeZone: "Europe/Paris",
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};